/**
 * Matemática do contador regressivo, separada do componente para poder ser
 * testada sem renderizar nada.
 *
 * A regra que importa: o tempo restante é sempre recalculado a partir do
 * instante absoluto de término. Nada é decrementado nem guardado. Um contador
 * que decrementa um número próprio diverge do horário real assim que a aba fica
 * em segundo plano, e volta errado depois de um refresh.
 */

/** Milissegundos até `endsAt`, ou `null` quando não há prazo real. */
export function restanteMs(endsAt, agora = Date.now()) {
    if (!endsAt) return null;
    const fim = new Date(endsAt).getTime();
    if (Number.isNaN(fim)) return null;
    return Math.max(0, fim - agora);
}

/** `02:14:37`, ou `3d 02:14:37` quando passa de um dia. */
export function formataRestante(ms) {
    const total = Math.floor(ms / 1000);
    const dias = Math.floor(total / 86400);
    const h = Math.floor((total % 86400) / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const dd = (n) => String(n).padStart(2, '0');
    return dias > 0 ? `${dias}d ${dd(h)}:${dd(m)}:${dd(s)}` : `${dd(h)}:${dd(m)}:${dd(s)}`;
}

/** Só há countdown quando existe um fim real e ainda no futuro. */
export function temCountdown(endsAt, agora = Date.now()) {
    const ms = restanteMs(endsAt, agora);
    return ms !== null && ms > 0;
}
